import { toast } from 'react-hot-toast';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { CheckSmallCircleFillIcon, ExclamationmarkSmallCircleFillIcon } from '@/icons';
import { Button } from '@/ui_v3';

/** 토스트 우측에 선택적으로 노출하는 액션 버튼. */
export type SuccessToastAction = {
  label: string;
  onClick: () => void;
};

/**
 * quiz-app 공통 성공 토스트. 밝은 글래스 표면 + positive 체크 아이콘 + 진한 텍스트.
 * `action` 을 주면 우측에 버튼(예: "클래스로 이동")을 함께 노출한다(기본: 버튼 없음).
 */
export function SuccessToast({
  message,
  action
}: {
  message: string;
  action?: SuccessToastAction;
}) {
  return <div className="flex min-h-[48px] items-center gap-lg rounded-sm bg-opacity-white-10 p-sm shadow-lg backdrop-blur-[2px]" data-sentry-component="SuccessToast" data-sentry-source-file="SuccessToast.tsx">
      <div className="flex items-center gap-xs">
        <CheckSmallCircleFillIcon size="md" fill={ICON_COLOR.positive} data-sentry-element="CheckSmallCircleFillIcon" data-sentry-source-file="SuccessToast.tsx" />
        <span className="pr-lg text-body-lg-semibold text-default">
          {message}
        </span>
      </div>
      {action && <Button variant="outlined" intent="neutral" size="sm" onClick={action.onClick}>
          {action.label}
        </Button>}
    </div>;
}
export function ErrorToast({
  message
}: {
  message: string;
}) {
  return <div className="flex min-h-[48px] items-center gap-xs rounded-sm bg-opacity-white-10 p-sm shadow-lg backdrop-blur-[2px]" data-sentry-component="ErrorToast" data-sentry-source-file="SuccessToast.tsx">
      <ExclamationmarkSmallCircleFillIcon size="md" fill={ICON_COLOR.destructive} data-sentry-element="ExclamationmarkSmallCircleFillIcon" data-sentry-source-file="SuccessToast.tsx" />
      <span className="pr-lg text-body-lg-semibold text-default">
        {message}
      </span>
    </div>;
}

/** 성공 토스트를 상단 중앙에 띄운다(react-hot-toast custom 렌더). */
export const showSuccessToast = (message: string, options?: {
  action?: SuccessToastAction;
  duration?: number;
}) => toast.custom(<SuccessToast message={message} action={options?.action} />, {
  position: 'top-center',
  duration: options?.duration ?? 2000
});
export const showErrorToast = (message: string, options?: {
  duration?: number;
}) => toast.custom(<ErrorToast message={message} />, {
  position: 'top-center',
  duration: options?.duration ?? 2000
});